import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="top-right"
      className="toaster group"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:border-l-4 group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "group-[.toast]:text-muted-foreground group-[.toast]:hover:text-foreground",
          success:
            "group-[.toaster]:!border-l-green-500 group-[.toaster]:!bg-green-50 group-[.toaster]:!text-green-900 dark:group-[.toaster]:!bg-green-950 dark:group-[.toaster]:!text-green-100",
          error:
            "group-[.toaster]:!border-l-red-500 group-[.toaster]:!bg-red-50 group-[.toaster]:!text-red-900 dark:group-[.toaster]:!bg-red-950 dark:group-[.toaster]:!text-red-100",
          warning:
            "group-[.toaster]:!border-l-yellow-500 group-[.toaster]:!bg-yellow-50 group-[.toaster]:!text-yellow-900 dark:group-[.toaster]:!bg-yellow-950 dark:group-[.toaster]:!text-yellow-100",
          info:
            "group-[.toaster]:!border-l-blue-500 group-[.toaster]:!bg-blue-50 group-[.toaster]:!text-blue-900 dark:group-[.toaster]:!bg-blue-950 dark:group-[.toaster]:!text-blue-100",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
